<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getB2bWarehouse,
  add,
  del,
  update,
  getDetails,
  getB2bWarehouseConfig
} from "@/api/system/b2b_warehouse";

import cTable from "@/base/common/index";
export default {
  name: "b2b_warehouse",
  components: {
    cTable
  },
  async mounted() {
    this.selectData = (await getB2bWarehouseConfig()).data.payload;
  },
  data() {
    return {
      selectData: {},
      methods: {
        list: getB2bWarehouse,
        getDetails,
        del,
        add,
        update,
        getB2bWarehouseConfig
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              service_code: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "array",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              to_city_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              to_city_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              warehouse_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              detailed_address: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              phone: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              is_enable: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { service_code: 24 },
            // { from_country: 24 },
            { to_country: 24 },
            { to_city_name: 24 },
            { warehouse_name: 24 },
            { detailed_address: 24 },
            { phone: 24 },
            { is_enable: 24 }
          ],
          fields: [
            {
              name: () => this.$t("company"),
              key: "service_code",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("company");
              },
              options: [],
              config: {
                label: "service_name",
                value: "service_code"
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["service"];
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("allow_depart"),
              key: "from_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("allow_depart");
              },
              options: [],
              config: {
                label({ row }) {
                  return row.title + "(" + row.code + ")";
                },
                value: "code"
              },
              bind: {
                multiple: true
              },
              default: "*",
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("allow_arrive"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("allow_arrive");
              },
              options: [],
              config: {
                label({ row }) {
                  return row.title + "(" + row.code + ")";
                },
                value: "code"
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("city_name"),
              key: "to_city_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("allow_arrive");
              }
            },
            {
              name: () => this.$t("warehouseName"),
              key: "warehouse_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("warehouseName");
              }
            },
            {
              name: () => this.$t("warehouseAddress"),
              key: "detailed_address",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("warehouseAddress");
              },
              bind: {
                type: "textarea",
                rows: 3
              }
            },
            {
              name: () => this.$t("phone"),
              key: "phone",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("phone");
              }
            },
            {
              name: () => this.$t("enable") + this.$t("disable"),
              key: "is_enable",
              component: "Radio",
              options: [
                {
                  label: this.$t("enable"),
                  value: "YES"
                },
                {
                  label: this.$t("disable"),
                  value: "NO"
                }
              ],
              bind: { border: true },
              default: "YES"
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("company"),
          key: "service_code",
          width: 150,
          align: "left"
        },
        // {
        //   name: () => this.$t("allow_depart"),
        //   key: "from_country",
        //   width: 80
        // },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          width: 80
        },
        {
          name: () => this.$t("city_name"),
          key: "to_city_name",
          align: "left",
          minWidth: 150
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("warehouseAddress"),
          key: "detailed_address",
          align: "left",
          minWidth: 200
        },
        {
          name: () => this.$t("phone"),
          key: "phone",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("enable") + "/" + this.$t("disable"),
          key: "is_enable",
          width: 100
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          width: 150,
          align: "left"
        },
        {
          name: () => this.$t("update") + this.$t("time"),
          key: "update_time",
          width: 150,
          align: "left"
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete"
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").open(res.payload, function() {
                  this.setTitle(this.$t("update"));
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
